
import store_stock from '@/store/mods/stock/produits'
import $ from 'jquery'

export default {
    name: 'l-consommable',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
            liste_consommables: [],
        }
    },
    
    computed: {

    },

    mounted() {
        this.fetchConsommables()
    },

    methods: {
        fetchConsommables() {
            this.is_loading = true
            this.is_load_error = false

            store_stock.getListeConsommables().then((response) => {
                this.liste_consommables = response
                this.is_empty = this.liste_consommables.length === 0
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        toutSelectionner() {
            const is_checked = $('#consommable-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = this.liste_consommables.map((consommable) => ({ id: consommable.id, libelle: consommable.libelle }))
            } else {
                this.one_is_checked = []
            }

            this.all_checked = is_checked
        },
    }
}